import {clsx} from 'clsx';
import {isContainerQueryAvailable} from './container-query-with-fallback';
import styles from './follow-button.module.css';

type Props = {
  readonly isFollowing: boolean;
  readonly onClick: () => void;
  readonly isDisabled?: boolean;
};

export function FollowButton({isFollowing, onClick, isDisabled}: Props) {
  return (
    <button
      type='button'
      className={clsx(
        styles.button,
        isFollowing
          ? styles.buttonVariantsOutline
          : styles.buttonVariantsPrimary,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      disabled={isDisabled}
      onClick={onClick}
    >
      {isFollowing ? 'フォロー中' : 'フォロー'}
    </button>
  );
}

export function FollowButtonReadonly() {
  return (
    <span
      className={clsx(
        styles.button,
        styles.buttonVariantsReadonly,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      フォロー
    </span>
  );
}
